import { displayRestrictionTypeSchema } from './display-restriction-type.schema';
import { z } from 'zod/v4';

export const coPilotOptionsSchema = z.object({
  displayRestrictions: displayRestrictionTypeSchema,
});

export type CoPilotOptions = z.infer<typeof coPilotOptionsSchema>;
